/* eslint-disable @typescript-eslint/camelcase */
import { Grid } from '@material-ui/core';
import i18n from 'i18n';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { PartnerFormFields } from 'modules/partners/interfaces';
import PartnersTemplate from '../PartnersTemplate';
import CustomPartnerFront from '../CustomPartnerFront';

interface Props {
  partner: PartnerFormFields | null;
}

const CustomFront = ({ partner }: Props) => {
  return (
    <PartnersTemplate
      current="custom-front"
      partnerName={partner?.name}
      breadcrumbs={[
        {
          name: i18n.t('PARTNERS_KEY'),
          link: '/partners',
        },
        {
          name: i18n.t('GROUPS_PAGE.FRONTEND_CUSTOMIZATION_KEY'),
        },
      ]}
    >
      <Grid container>
        <CustomPartnerFront />
      </Grid>
    </PartnersTemplate>
  );
};

const mapStateToProps = ({
  partners: { partnerDetails },
}: ApplicationState) => ({
  partner: partnerDetails,
});

export default connect(mapStateToProps, {})(CustomFront);
